/**
 */
export default {
  isUserName(str: string) {
    return /^[0-9a-zA-Z]+$/.test(str);
  },
  // 手机号正则
  isPhone(str: any) {
    // 2021.3.9 修正： 因为当前19号段不只限于198、199, 根据人力的要求，手机号不再限制第三位
    // return /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/.test(str);
    return /^(13|14|15|16|17|18|19)\d{9}$/.test(str);
  },
  // 验证码正则 四位正整数
  isCode(str: any, len: any) {
    if (len === 4) {
      return /^[0-9]\d{0,4}$/.test(str);
    }
    if (len === 6) {
      return /^[0-9]\d{0,6}$/.test(str);
    }
  },
  // 邮箱验证
  isEmail(str: any) {
    return /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(str);
  },
  // 0-9数字
  isNumber(str: any) {
    return /^[0-9]+$/.test(str);
  },
  isCarnumber(str: any) {
    return /^[\u4e00-\u9fa5]{1}[A-Z]{1}[A-Z_0-9]{5}$/.test(str);
  },
  // 数字与英文字母
  isNumOrWord(str: any) {
    return /^[A-Za-z0-9]+$/.test(str);
  },
};
